import React, {useEffect} from 'react';
import clsx from 'clsx';
import {useSelector, useDispatch } from 'react-redux';
import {
  Dispatch
} from 'redux';
import {IntlProvider, FormattedMessage} from 'react-intl';
import { useHistory } from "react-router-dom";
import GlobalActions from 'stores/global/actions';
import _ from 'lodash';
import { 
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Box,
  CircularProgress,
  Icon,
  IconButton,
  useMediaQuery
 } from '@material-ui/core';
 import isMobile from 'ismobilejs';
import { withStyles, ThemeProvider, makeStyles, createTheme, Theme} from '@material-ui/core/styles';
import BasicTheme from 'themes'; 

export type DialogProps = {
  configName?:string;
  themeName?:string;
  options?:DialogOptions;
  previewTheme?: Theme,
  configs?:DialogConfigs
}

export type DialogConfigs ={
  dialogBorder?: boolean;
  titleBorder?: boolean;
  actionBorder?: boolean;
  actionFullWidth?: boolean;
  actionColumnReverse?: boolean;
  buttonSize?: 'large' | 'medium' | 'small'
}

export type DialogOptions = {
  confirm?: boolean | undefined;
  visible?: boolean;
  close?: boolean;
  fullScreen?: boolean | undefined;
  mobileFullScreen?:boolean | undefined;
  mobileVertical?:'flex-start' | 'center' | 'flex-end'
  title?: string;
  titleComponent?:React.ReactNode;
  contentComponent?: React.ReactNode;
  dialogComponent?: React.ReactNode;
  loading?: boolean | undefined;
  confirmAction?(dispatch?:Dispatch<any>, history?:any): void |  null | undefined | unknown;
  confirmVariant?: 'contained' | 'outlined';
  confirmColor?: 'primary' | 'secondary';
  confirmText?:string;
  cancelAction?(dispatch?:Dispatch<any>, history?:any): void | null | undefined | unknown;
  cancelVariant?: 'contained' | 'outlined';
  cancelColor?: 'primary' | 'secondary';
  cancelText?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' //[xs,sm,md,lg]
}


const useStyles = makeStyles((theme) => {
  return {
    itemGroup: {
      display: 'flex',
      margin: -theme.spacing(1),
      '& > *': {
        margin: theme.spacing(1),
      }
    },
    columnReverseGroup: {
      display: 'flex',
      flexDirection: 'column-reverse',
      margin: `${-theme.spacing(1)}px 0`,
      '& > *': {
        margin: `${theme.spacing(1)}px 0`,
      }
    },
    closeBtn: {
      position: 'absolute',
      right: 24,
      top: '30%'
    }
  }
})


const LBDialog = (props:DialogProps) => {
  const {configName, themeName, options, configs, previewTheme} = props;
  const componentConfig = configs || require(`./${configName || 'config'}.json`);
  const componentTheme = require(`./${themeName || 'theme'}.json`);
  const global = useSelector( (state:any) => state.global);
  const classes = useStyles();
  const dispatch = useDispatch();
  const dialogSetting:DialogOptions = options || global.globalDialog;
  const history = useHistory();
  const defaultTheme = createTheme(_.defaultsDeep(componentTheme, BasicTheme))
  // const matches = useMediaQuery(defaultTheme.breakpoints.down('xs'));
  const matches = isMobile().any;
  const theme = createTheme(_.defaultsDeep({
    overrides: {
      MuiDialog: {
        paper: {
          border: componentConfig.dialogBorder ? `1px solid ${defaultTheme.palette.border.main}` : 'none'
        },
        scrollPaper: {
          alignItems: dialogSetting.mobileVertical || 'center'
        },
        paperFullScreen: {
          height: dialogSetting.mobileVertical ? '50%' : '100%'
        }
      },
      MuiDialogTitle: {
        root: {
          position: 'relative',
          borderBottom: componentConfig.titleBorder ? `1px solid ${defaultTheme.palette.border.main}` : 'none',
          '& > *': {
            minHeight: 30
          }
        }
      },
      MuiDialogContent: {
        root: {
          padding: defaultTheme.spacing(3)
        }
      },
      MuiDialogActions: {
        root: {
          borderTop: componentConfig.actionBorder ? `1px solid ${defaultTheme.palette.border.main}` : 'none',
          padding: `${BasicTheme.spacing(3)}px ${BasicTheme.spacing(componentConfig.actionFullWidth && !componentConfig.actionColumnReverse ? 2 : 3)}px`,
          justifyContent: componentConfig.actionFullWidth ? 'center' : 'flex-end'
        }
      }
    }
  }, previewTheme || defaultTheme));

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={!!dialogSetting.visible}
        fullWidth
        fullScreen={dialogSetting.fullScreen || (matches && (!!dialogSetting.mobileVertical || dialogSetting.mobileFullScreen))}
        maxWidth={dialogSetting.maxWidth}
        >
          {
            (dialogSetting.titleComponent || dialogSetting.title || dialogSetting.close) &&
            <DialogTitle>
              {
                dialogSetting.titleComponent
              }
              {
                !dialogSetting.titleComponent && dialogSetting.title &&
                  <Box whiteSpace="pre-line">
                    {
                      typeof dialogSetting.title === 'string' && <FormattedMessage id={dialogSetting.title} /> || ''
                    }
                  </Box>
              }
              {
                dialogSetting.close &&
                <IconButton className={classes.closeBtn} onClick={() => {
                  dispatch(GlobalActions.toogleDialog({visible: false}));
                  if(options) {
                    dialogSetting.visible= false
                  }
                }} size="small">
                  <Icon>close</Icon>
                </IconButton>
              }
            </DialogTitle>
          }
          {
          !dialogSetting.dialogComponent && dialogSetting.contentComponent &&
            <DialogContent>
            
                <>
                  {
                    typeof dialogSetting.contentComponent === 'object' && dialogSetting.contentComponent
                  }
                  {
                    typeof dialogSetting.contentComponent === 'function' && <dialogSetting.contentComponent />
                  }
                  {
                    typeof dialogSetting.contentComponent === 'string' && <Box whiteSpace="pre-line"><FormattedMessage id={dialogSetting.contentComponent} /></Box>
                  }
                </>
            
              
            </DialogContent>
           }
          {
            dialogSetting.dialogComponent && (typeof dialogSetting.dialogComponent == 'function') ? <dialogSetting.dialogComponent /> : dialogSetting.dialogComponent
          }
        {
          !dialogSetting.dialogComponent &&
            <DialogActions disableSpacing>
              <Box display="flex" className={clsx({
                [classes.itemGroup]: !componentConfig.actionColumnReverse,
                [classes.columnReverseGroup]: componentConfig.actionColumnReverse
              })} width={componentConfig.actionFullWidth ? 1 : 'initial'}>
                {
                  dialogSetting.confirm &&
                  
                    <Button size={componentConfig.buttonSize || 'medium'} data-test-id="dialog-button-cancel" fullWidth disabled={dialogSetting.loading} variant={dialogSetting.cancelVariant || 'outlined'} color={dialogSetting.cancelColor || 'secondary'} onClick={() => {
                      if(typeof dialogSetting.cancelAction === 'function') {
                        dialogSetting.cancelAction(dispatch, history)
                      } else {
                        dispatch(GlobalActions.toogleDialog({visible: false}));
                        if(options) {
                          dialogSetting.visible= false
                        }
                      }
                    }}>
                      <FormattedMessage id={dialogSetting.cancelText  || 'action.cancel'}/>
                    </Button> 
                  
                }
                <Button size={componentConfig.buttonSize || 'medium'} data-test-id="dialog-button-confirm" disabled={dialogSetting.loading} fullWidth variant={dialogSetting.confirmVariant || 'contained'} color={dialogSetting.confirmColor || 'primary'} onClick={() => {
                  if(typeof dialogSetting.confirmAction === 'function') {
                    dialogSetting.confirmAction(dispatch, history)
                  } else {
                    dispatch(GlobalActions.toogleDialog({visible: false}));
                    if(options) {
                      dialogSetting.visible= false
                    }
                  }
                }}>
                  { dialogSetting.loading && <CircularProgress size={24}/>  }
                  <FormattedMessage id={dialogSetting.confirmText  || 'action.confirm'}/>
                </Button> 
              </Box>
          </DialogActions>
        }
      </Dialog>
    </ThemeProvider>
  )
}

export default LBDialog;
